// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--wH+X7";
export var blockquote = "styles-module--blockquote--lNMJa";
export var header = "styles-module--header--qIwhi";
export var title = "styles-module--title--8G+Oz";
export var text = "styles-module--text--6RgBi";